<template>
    <div class="container">
        <div class="header" :class="{'show': !isUnfold}">
            <div id="filterEl">
                <div v-for="item in filterHeader" :key="item.model">
                    <div class="item" v-if="item.type === 'input'">
                        <span class="label">{{item.label}}：</span>
                        <el-input v-model="defaultQuery[item.model]"
                            :disabled = "item.disabled || false" :placeholder="`${item.placeholder ? item.placeholder : `输入${item.label}`}`" size="small" style="width: 210px;" clearable @keyup.enter.native="search"></el-input>
                    </div>
                    <div class="item" v-if="item.type === 'monthrange'">
                        <span class="label">{{item.label}}：</span>
                        <el-date-picker
                            v-model="defaultQuery[item.model]"
                            :disabled = "item.disabled || false"
                            :picker-options="setMonthPickerOptions(item.notDisabled)"
                            format="yyyy/MM"
                            value-format="timestamp"
                            type="monthrange"
                            range-separator="至"
                            start-placeholder="开始月份"
                            end-placeholder="结束月份"
                            align="right"
                            size="small"
                            unlink-panels
                            style="width: 210px;">
                        </el-date-picker>
                    </div>
                    <div class="item" v-if="item.type === 'daterange'">
                        <span class="label">{{item.label}}：</span>
                        <el-date-picker
                            v-model="defaultQuery[item.model]"
                            :disabled = "item.disabled || false"
                            :picker-options="setPickerOptions(item.notDisabled)"
                            format="yyyy/MM/dd"
                            value-format="timestamp"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            align="right"
                            size="small"
                            unlink-panels
                            style="width: 210px;">
                        </el-date-picker>
                    </div>
                    <div class="item" v-if="item.type === 'datetimerange'">
                        <span class="label">{{item.label}}：</span>
                        <el-date-picker 
                            v-model="defaultQuery[item.model]" 
                            :disabled = "item.disabled || false"
                            :picker-options="setPickerOptions(item.notDisabled)" 
                            format="yyyy/MM/dd HH:mm:ss"
							value-format="timestamp"
                            type="datetimerange" 
                            range-separator="至" 
                            start-placeholder="开始日期" 
                            end-placeholder="结束日期" 
                            align="right"
                            size="small"
							unlink-panels
                            style="width: 210px;">
                        </el-date-picker>
                    </div>
                    <div class="item" v-if="item.type === 'textarea'">
                        <span class="label">{{item.label}}：</span>
                        <el-input v-model="defaultQuery[item.model]"
                            :disabled = "item.disabled || false" :placeholder="`${item.placeholder ? item.placeholder : `输入${item.label}`}`" type="textarea" size="small" style="width: 210px;"></el-input>
                    </div>
                    <div class="item" v-if="item.type === 'select'">
                        <span class="label">{{item.label}}：</span>
                        <el-select v-model="defaultQuery[item.model]" collapse-tags :multiple="item.multiple" :placeholder="`${item.placeholder ? item.placeholder : `请选择`}`" size="small" style="width: 210px;" clearable filterable :disabled = "item.disabled || false">
                            <!-- <el-option :key="-1" label="全部" value=""></el-option> -->
                            <el-option v-for="(_item,index) in item.list" :key="index" :label="item.labelName?_item[item.labelName]:_item.name" :value="item.valueName?_item[item.valueName]:_item.id"></el-option>
                        </el-select>
                    </div>
					<div class="item" v-if="item.type === 'selectRemote'">
					    <span class="label">{{item.label}}：</span>
					    <el-select remote :remote-method="(query) => remoteMethod(query,item)" @focus="onFocus(item)" @change="onFocus(item)" :loading="loading" v-model="defaultQuery[item.model]" collapse-tags :multiple="item.multiple" :placeholder="`${item.placeholder ? item.placeholder : `请选择`}`" size="small" style="width: 210px;" clearable filterable :disabled = "item.disabled || false">
					       <el-option v-for="(_item,index) in list_options[item.model]" :key="index" :label="getLabelName(item,_item)" :value="item.valueName?_item[item.valueName]:_item.id"></el-option>
					    </el-select>
					</div>
					<div class="item" v-if="item.type === 'select_date'">
                        <div class="selects-el">
                            <el-select v-model="defaultQuery[item.labelModel]" size="small" filterable placeholder="全部" style="width:100px"
                            :disabled = "item.disabled || false">
                                <el-option v-for="item in item.label" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                            <el-date-picker 
                                v-model="defaultQuery[item.model]" 
                                :picker-options="setPickerOptions(item.notDisabled)" 
                                format="yyyy/MM/dd HH:mm:ss"
								value-format="timestamp"
                                type="datetimerange" 
                                range-separator="至" 
                                start-placeholder="开始日期" 
                                end-placeholder="结束日期" 
                                align="right"
                                size="small"
								unlink-panels
                                style="width: 210px;">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="item" v-if="item.type === 'cascader'">
                        <span class="label">{{item.label}}：</span>
                        <el-cascader 
                            v-model="defaultQuery[item.model]" 
                            :options="item.list" 
                            :props="item.districtProps" 
                            style="width: 210px" 
                            size="small"
                            clearable 
                            filterable>
                        </el-cascader>
                    </div>
					<div class="item table-search-item-tabs" v-if="item.type == 'tabs'">
						<span class="label">{{item.label}}：</span>
						<span class="tab" @click="onSwitch(_item,item.model)" :class="{'active':_item.id == defaultQuery[item.model]}" v-for="(_item,_index) in item.list" :key="_index">{{_item.name}}</span>
					</div>
					<div class="item" v-if="item.type == 'radioStyle'">
						<span class="label">{{item.label}}：</span>
						<el-radio-group v-model="defaultQuery[item.model]" size="mini">
							<el-radio-button v-for="(item,index) in item.list" :key="index" :label="item.id">{{item.name}}</el-radio-button>
						</el-radio-group>
					</div>
					<template v-if="item.type == 'dynamic'">
						<slot></slot>
					</template>
					
                </div>
            </div>
            <div>
                <div>
                    <el-button @click.stop="resetFilter" icon="el-icon-refresh-right" size="small">重置</el-button>
                    <el-button @click.stop="search" icon="el-icon-search" size="small" type="primary">查询</el-button>
                </div>
                <div v-if="isShowMore" @click.stop="isUnfold = !isUnfold">更多查询<i :class="{'el-icon-caret-right': isUnfold, 'el-icon-caret-bottom': !isUnfold}"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import { pickerOptionsMixin } from "utils/mixins";
export default {
    name: 'TableSearch',
    mixins: [pickerOptionsMixin],
	props:{
		'filterHeader':{
			required:true
		},
		'defaultQuery':{
			required:true
		},
		'pageNumber':{
			default:'pageNumber'
		}
	},
	data() {
		return {
            isUnfold: true,
            isShowMore: false,
			loading:false,
			list_options:{
				
			}
		}
    },
	watch: {
		'$route':{
			handler(val){
				if(val.query.subjectId){
					this.getSubjectId(this.filterHeader[2]);
				}
			},
			immediate:true
		},
	},
    mounted() {
		let self = this;
		if(document.getElementById('filterEl')) {
			const space = Math.floor(document.getElementById('filterEl')?.offsetWidth / 300);
			self.isShowMore = self.filterHeader.length > space;
			window.onresize = function(){
				const space = Math.floor(document.getElementById('filterEl')?.offsetWidth / 300);
				self.isShowMore = self.filterHeader.length > space;
			}
		}
    },
	methods: {
		getLabelName(item,_item){
			if(!item.labelName) return _item.name;
			if(!item.childLabelName) return _item[item.labelName];
			return _item[item.labelName] + `【${_item[item.childLabelName]}】`
		},
		onFocus(row,query){
			this.loading = true;
			switch(row.model){
				case 'campaignId': //外呼活动
					this.getCampaignId(row,query);
					break;
				case 'subjectId': //外呼主题
					this.getSubjectId(row,query);
					break;
				case 'originalBatchNum': //数据批次
				case 'batchNum': //数据批次
					this.getBatchNum(row,query);
					break;
				case 'paperId': //外呼问卷
					this.getPaperId(row,query);
					break;
				case 'userId': //所有人员
					this.geUserId(row,query);
					break;
				case 'taskStatus': //任务状态
					this.getTaskStatus(row,query);
					break;
					
			}
		},
		remoteMethod(query,row){
			this.loading = true;
			this.onFocus(row,query)
		},
		async search() {
            this.defaultQuery[this.pageNumber] = 1;
            await this.$emit('filterSearch', this.defaultQuery);
        },
        resetFilter() {
            for(let item of this.filterHeader) {
                this.defaultQuery['pageSize'] = 10;
                this.defaultQuery[this.pageNumber] = 1;
                this.defaultQuery[item.model] = item.default;
            }
			this.$emit('resetBasicFilter')
        },
        setPickerOptions(type) {
            let pickerOptions = Object.assign({}, this.pickerOptions);
            if (type) delete pickerOptions.disabledDate;
            return pickerOptions;
        },
        setMonthPickerOptions(type){
            let pickerOptions = Object.assign({}, this.monthPickerOptions);
            if (type) delete pickerOptions.disabledDate;
            return pickerOptions;
        },
		onSwitch(row, type){
			this.$emit('onSwitch',{
				key: type,
				data: row
			})
		},
		getCampaignId(row,val){
			this.$api.getBreathThemeTypesList({
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
				childBrandIdentify:this.defaultQuery.childBrandIdentify,
				campaignName: val || '',
				pageSize:50,
				pageNumber:1,
			}).then(res => {
				this.loading = false;
				if(res.errcode != 0) return;
				this.list_options[row.model] = res.data;
			})
		},
		getSubjectId(row,val){
			this.$api.getBreathThemeList({
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
				childBrandIdentify:this.defaultQuery.childBrandIdentify,
				campaignId:this.defaultQuery.campaignId || '',
				pageSize:50,
				pageNumber:1,
				subjectName: val || ''
			}).then(res => {
				this.loading = false;
				if(res.errcode != 0) return;
				this.list_options[row.model] = res.data;
				let index = this.filterHeader.findIndex(el => el.model == 'originalBatchNum' || el.mode == 'batchNum');
				if(index != -1){
					this.getBatchNum(this.filterHeader[index])
					this.$emit('onSubjectLists',res.data);
				}
				
			})
		},
		getTaskStatus(row,val){
			this.$api.getBreathTaskStatus({
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
			}).then(res => {
				this.loading = false;
				if(res.errcode != 0) return;
				this.list_options[row.model] = res.data;
			})
		},
		getBatchNum(row,val){
			this.$api.getBreathdataBaseFileList({
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
				pageNumber:1,
				pageSize:50,
				childBrandIdentify:this.defaultQuery.childBrandIdentify,
				name: val || '',
				subjectId:this.defaultQuery.subjectId
			}).then(res => {
				this.loading = false;
				if(res.errcode != 0) return;
				this.list_options[row.model] = res.data;
			})
		},
		getPaperId(row,val){
			this.$api.apiGetSurveyPaperList({
				pageSize: 50,
				pageNumber: 1,
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
				subBrandIdentify: this.defaultQuery.childBrandIdentify,
				paperName: val || '',
				paperStatus: '0',
				channelIdentify: '',
				paperId: '',
			}).then(res => {
				this.loading = false;
				if(res.errcode != 0) return;
				this.list_options[row.model] = res.data;
				
			})
		},
		geUserId(row,val){
			let params = {
				data: {
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
				    account:  val || '',
				    userType: '',
				},
				orderBy: null,
				pageNum: 1,
				pageSize: 50
			}
			if(this.defaultQuery.childBrandIdentify){
				params.data.brandList = [this.defaultQuery.childBrandIdentify];
			}
			this.$api.getAllPlatformUserList(params).then(res => {
				this.loading = false;
				if(res.errcode != 0) return;
				this.list_options[row.model] = res.list;
				
			})
		}
    }
}
</script>

<style lang="scss" scoped>
::v-deep .selects-el {
    & .el-select:nth-child(1) {
        width: 142px;
        & .el-input {
        & .el-input__inner {
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
            background-color: #f5f7fa;
            border-color: #DCDFE6;
            border-right: 0;
        }
        }
    }
    & .el-select:nth-child(2) {
        & .el-input {
            & .el-input__inner {
                border-bottom-left-radius: 0;
                border-top-left-radius: 0;
            }
        }
    }
    & .el-date-editor {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        vertical-align: middle;
    }
}
.table-search-item-tabs {
	.tab {
		padding: 3px 5px;
		cursor: pointer;
		font-size: 14px;
		&.active {
			background-color: #0F81FB;
			color: #fff;
			border-radius: 2px;
		}
	}
}

</style>